{
  "nl": {
    "company": {
      "actions": {
        "changeCompany": "Verander organisatie",
        "searchCompany": "Zoek organisatie"
      },
      "attributes": {
        "address": "Adres",
        "email_address": "Email",
        "iban": "IBAN",
        "language": "Taal",
        "name": "Organisatienaam",
        "phone": "Telefoon",
        "subdomain": "Subdomein",
        "vat": "BTW"
      },
      "labels": {
        "company": "Organisatie",
        "contact": "Contactpersoon",
        "contacts": "Contactpersonen",
        "language": "Dit is de standaardtaal van de organisatie voor jouw inlogpagina, klanten en teamleden.",
        "or": "OF"
      },
      "validation": {
        "contactAlreadyExist": "Contactpersoon bestaat al reeds",
        "mustBeEmailAddress": "Valide emailadres vereist",
        "needName": "Naam is vereist"
      }
    }
  }
}
